export type UnderlyingType = {
  id: string;
  name: string;
  orderIndex: number;
};

export const UNDERLYINGS: UnderlyingType[] = [
  {
    id: 'BBSW',
    name: 'BBSW',
    orderIndex: 1,
  },
  {
    id: 'BUBO',
    name: 'BUBOR',
    orderIndex: 1,
  },
  {
    id: 'BSKT',
    name: 'Basket',
    orderIndex: 1,
  },
  {
    id: 'CDOR',
    name: 'CDOR',
    orderIndex: 1,
  },
  {
    id: 'CIBO',
    name: 'CIBOR',
    orderIndex: 1,
  },
  {
    id: 'CZNA',
    name: 'CZEONIA',
    orderIndex: 1,
  },
  {
    id: 'EFFR',
    name: 'Effective Federal Funds Rate',
    orderIndex: 1,
  },
  {
    id: 'EONA',
    name: 'EONIA',
    orderIndex: 1,
  },
  {
    id: 'EONS',
    name: 'EONIA SWAP',
    orderIndex: 1,
  },
  {
    id: 'ESTR',
    name: '€STR',
    orderIndex: 1,
  },
  {
    id: 'EURI',
    name: 'EURIBOR',
    orderIndex: 1,
  },
  {
    id: 'EUUS',
    name: 'EuroDollar',
    orderIndex: 1,
  },
  {
    id: 'EUCH',
    name: 'EuroSwiss',
    orderIndex: 1,
  },
  {
    id: 'FUSW',
    name: 'Future SWA',
    orderIndex: 1,
  },
  {
    id: 'GCFR',
    name: 'GCF REPO',
    orderIndex: 1,
  },
  {
    id: 'ISDA',
    name: 'ISDAFIX',
    orderIndex: 1,
  },
  {
    id: 'JIBA',
    name: 'JIBAR',
    orderIndex: 1,
  },
  {
    id: 'LIBI',
    name: 'LIBID',
    orderIndex: 1,
  },
  {
    id: 'LIBO',
    name: 'LIBOR',
    orderIndex: 1,
  },
  {
    id: 'MAAA',
    name: 'Muni AAA',
    orderIndex: 1,
  },
  {
    id: 'MOSP',
    name: 'MOSPRIM',
    orderIndex: 1,
  },
  {
    id: 'NIBO',
    name: 'NIBOR',
    orderIndex: 1,
  },
  {
    id: 'OBFR',
    name: 'Overnight Bank Funding Rate',
    orderIndex: 1,
  },
  {
    id: 'PFAN',
    name: 'Pfandbriefe',
    orderIndex: 1,
  },
  {
    id: 'PRBO',
    name: 'PRIBOR',
    orderIndex: 1,
  },
  {
    id: 'STBO',
    name: 'STIBOR',
    orderIndex: 1,
  },
  {
    id: 'SWAP',
    name: 'SWAP',
    orderIndex: 1,
  },
  {
    id: 'TIBO',
    name: 'TIBOR',
    orderIndex: 1,
  },
  {
    id: 'TLBO',
    name: 'TELBOR',
    orderIndex: 1,
  },
  {
    id: 'TONA',
    name: 'TONA',
    orderIndex: 1,
  },
  {
    id: 'TREA',
    name: 'Treasury',
    orderIndex: 1,
  },
  {
    id: 'WIBO',
    name: 'WIBOR',
    orderIndex: 1,
  },
];

export const ORDERED_UNDERLYINGS = UNDERLYINGS.sort((a, b) => a.orderIndex - b.orderIndex);
